<template>
  <div class="ui-content dashboard leader-sub table-margin-15">
    <div class="past-test-dropdown">
      <v-select
        :items="testTypesList"
        v-model="selectedTest"
        hide-details
      ></v-select>
    </div>
    <div>
      <InstituteTest v-if="selectedTest == 'institute'" />
      <PreviousYearTest v-else-if="selectedTest == 'premium'" />
      <ReadyMadeTest v-else-if="selectedTest === 'self'" />
    </div>
  </div>
</template>

<script>
import InstituteTest from "@/components/student/Tests/PastTests/InstituteTest.vue";
import ReadyMadeTest from "@/components/student/Tests/PastTests/ReadyMadeTest.vue";
import PreviousYearTest from "@/components/student/Tests/PastTests/PreviousYearTest.vue";
import { mapState, mapMutations } from "vuex";
import constants from '../../../utils/constants';
export default {
  name: "PastTest",
  components: {
    InstituteTest,
    PreviousYearTest,
    ReadyMadeTest,
  },
  mounted() {
    this.defaultData();
    this.checkSessionData();
    localStorage.removeItem("prevPath");
    localStorage.setItem("prevPath", this.$route.name);
  },
  computed: {
    ...mapState("userStore", ["user","myInstitute"]),
  },
  data() {
    return {
      testTypesList: [{ text: "Institute Tests", value: "institute" }],
      selectedTest: null,
    };
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    defaultData() {
      // this.selectedTest = this.testTypesList[0].value;
      if (!constants.CUSTOM_DOMAIN_ID.includes(this.myInstitute.id)) {
      this.testTypesList.push({ text: "Ready Made Tests", value: "premium" });
      this.testTypesList.push({ text: "Self-Made Tests", value: "self" });
      }
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.selectedTest = crd.selectedTab
          ? crd.selectedTab
          : this.testTypesList[0].value;
      }
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let details = {
          page: 1,
          orderBy: {
            field: "started",
            order: "DESC",
          },
          examTypes: [],
        };
        let tabDetail = {
          premium: _.cloneDeep(details),
          institute: _.cloneDeep(details),
          self: _.cloneDeep(details),
        };
        tabDetail.premium.orderBy.field = "test_name";
        tabDetail.premium.orderBy.order = "ASC";

        let routeDetails = {
          routeName: rp.name,
          selectedTab: this.selectedTest,
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
  },
  watch: {
    selectedTest(val, oldVal) {
      let breadCrumb = val == "premium" ? "Ready Made Tests" : val == "self" ? "Self Made Tests" : "Institute Tests";
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val });
      }
      this.addBreadCrumbChilde([
        {
          text: breadCrumb,
          disabled: false,
        },
      ]);
    },
  },
};
</script>
